import React, {useState} from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography"
import ScoreBoardTable from "./scoreboardtable";
import LogOut from "./signout";
import PlayerEntry from "./playerentry";
import Schedule from "./schedule";
import Games from "./games";

const headerFooterStyle = {
    padding: 8,
    textAlign: "center",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',
};

const mainStyle = {
    display:"flex",
    padding: 16,
    textAlign:"center",
    contentAlign:"center",
    justifyContent:"center",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',    
};

const buttonStyle = {
  border:"none",
  background: "rgb(186, 128, 219)",
  color: "rgb(255, 255, 255)",
  font: "20px",
  padding:"10px 15px",
  margin:"5px",
  cursor: "pointer"
}

const gameButtonStyle = {
  border:"none",
  background: "rgb(186, 128, 219)",
  color: "rgb(255, 255, 255)",
  font: "20px",
  padding:"10px 25px",
  margin:"5px",
  cursor: "pointer"
}

export default function AuthGrid(){
  
  const [displayPage, setDisplayPage] = useState("schedule");
    
  return (
        <div style={{flexGrow: 1}}>
          <Grid container spacing = {3}>
            <Grid item xs={12}>
                <Paper style={headerFooterStyle}>
                    <Typography component={'span'}>
                        <h1>High Score Challenge!</h1>
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs = {12}>
                <Paper style={headerFooterStyle}>
                    <Grid container direction={"row"} justifyContent={"center"} alignItems={"center"}>
                      <Grid item xs={4}>
                        <Typography><button style={buttonStyle} onClick={()=>setDisplayPage("playerentry")}><h4>Player Entry</h4></button></Typography>
                      </Grid> 
                      <Grid item xs={4}>
                        <Typography><button style={gameButtonStyle} onClick={() =>setDisplayPage("scoreboard")}><h4>Single Scoreboard</h4></button></Typography>
                      </Grid> 
                      <Grid item xs={4}>
                        <Typography><button style={gameButtonStyle} onClick={() =>setDisplayPage("twoscoreboard")}><h4>Two Scoreboard</h4></button></Typography>
                      </Grid>                 
                    </Grid>
                </Paper> 
            </Grid>
              <Grid item xs = {36}>
                <Grid container>
                  <Grid item xs = {36}>
                    <Paper style ={mainStyle}>
                      <Typography component={'span'}>
                          {displayPage ==="playerentry" && <PlayerEntry/>}
                          {displayPage ==="scoreboard" && <ScoreBoardTable/>}
                          {displayPage ==="schedule" && <Schedule/>}
                          {displayPage ==="games" && <Games/>}
                          {displayPage ==="logout" && <LogOut/>}
                          <Grid item xs={36}>
                            <Grid container spacing={12}>
                                <Grid item xs={6}>
                                    {displayPage ==="twoscoreboard" && <ScoreBoardTable/>}
                                </Grid>
                                <Grid item xs={6}>
                                    {displayPage ==="twoscoreboard" && <ScoreBoardTable/>}
                                </Grid>                          
                            </Grid>
                          </Grid>
                        </Typography>
                    
                    </Paper>
                  </Grid>    
                </Grid>
              </Grid>
                <Grid item xs={12}>
                  <Paper style={headerFooterStyle}>
                        <Grid container spacing={6} direction="row">
                            <Grid item xs={4}>
                                <Typography><button style={gameButtonStyle} onClick={() =>setDisplayPage("schedule")}><h4>Schedule</h4></button></Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography><button style={buttonStyle} onClick={() =>setDisplayPage("games")}><h4>Games</h4></button></Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography><LogOut/></Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
              </Grid> 
        </div>
    );
}
